import { render } from "./Aids.vue?vue&type=template&id=b26d7ddc&scoped=true"
import script from "./Aids.vue?vue&type=script&lang=js"
export * from "./Aids.vue?vue&type=script&lang=js"

import "./Aids.vue?vue&type=style&index=0&id=b26d7ddc&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Tepparad\\Tepparad-benefit-newver\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26d7ddc"]])

export default __exports__